import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuthStore } from './store/authStore';
import { getUserInfo } from './api/backend';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { PrestacoesPage } from './pages/PrestacoesPage';
import { PrestacaoDetalhePage } from './pages/PrestacaoDetalhePage';
import { NovoDocumentoPage } from './pages/NovoDocumentoPage';
import { NovaPrestacaoPage } from './pages/NovaPrestacaoPage';
import { NovaUnidadePage } from './pages/NovaUnidadePage';
import { UnidadesPage } from './pages/UnidadesPage';
import { PerfilPage } from './pages/PerfilPage';
import { RelatoriosPage } from './pages/RelatoriosPage';
import { DocumentosPage } from './pages/DocumentosPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuthStore();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!user?.display_name) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

function App() {
  const { setUser, setLoading } = useAuthStore();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const userInfo = await getUserInfo();
        if (userInfo.display_name) {
          setUser(userInfo, 'admin');
        } else {
          setLoading(false);
        }
      } catch (error) {
        console.error('Auth check error:', error);
        setLoading(false);
      }
    };

    checkAuth();
  }, [setUser, setLoading]);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/prestacoes"
          element={
            <ProtectedRoute>
              <PrestacoesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/prestacoes/nova"
          element={
            <ProtectedRoute>
              <NovaPrestacaoPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/prestacoes/:id"
          element={
            <ProtectedRoute>
              <PrestacaoDetalhePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/prestacoes/:id/documentos/novo"
          element={
            <ProtectedRoute>
              <NovoDocumentoPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/relatorios"
          element={
            <ProtectedRoute>
              <RelatoriosPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/documentos"
          element={
            <ProtectedRoute>
              <DocumentosPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/unidades/nova"
          element={
            <ProtectedRoute>
              <NovaUnidadePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/unidades"
          element={
            <ProtectedRoute>
              <UnidadesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/perfil"
          element={
            <ProtectedRoute>
              <PerfilPage />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
